import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Modal, Col, ModalBody, ListGroup, ListGroupItem } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';

const ModalKit = ({ dadComponent, detalleKit }) => {
    const VISIBLE = dadComponent.state.modalKit;
    const TOGGLE_MODAL = dadComponent['toggleModalKit'];
    const kitNombre =   dadComponent.state?.kit;
    // const [detalleKit, setDetalleKit] = useState([])
    // setDetalleKit( dadComponent.state.dataResult.detalleKit);    
    return (
        <div>
            <Modal returnFocusAfterClose={false} isOpen={VISIBLE} toggle={TOGGLE_MODAL} className='modal_kit' centered backdrop="static">
                <ModalBody>
                    <h6 className="title ">
                        <SvgAssets icon="icon-kit" fill={'#ED7F9A'} className="mr-3" />
                        {kitNombre}
                    </h6>
                    <ListGroup flush className="list-group-desktop">
                        <ListGroupItem className="header">
                            <Row form>
                                <Col xs={5} sm={7}>
                                    <span className='paragraph-3 desktop_parrafo3' style={{ color: c.azulClaro }}>Material</span>
                                </Col>
                                <Col xs={5} sm={3}>
                                    <span className='paragraph-3 desktop_parrafo3' style={{ color: c.verdeClaro }}>Código SKU</span>
                                </Col>
                                <Col xs={2} sm={2} className="text-center">
                                    <span className='paragraph-3 desktop_parrafo3' style={{ color: c.azulClaro }}>Cant.</span>
                                </Col>
                            </Row>
                        </ListGroupItem>
                        <div className='content-scroll'>
                            {(detalleKit != null && detalleKit.length > 0) ? detalleKit.map((data, index) => {
                            return (
                                <ListGroupItem key={index+1}>
                                    <Row form>
                                        <Col xs={5} sm={7}>
                                            <span className='paragraph-3 desktop_parrafo4' style={{ color: c.azulClaro }}>{data.maktx}</span>
                                        </Col>
                                        <Col xs={5} sm={3}>
                                            <span className='paragraph-3 sku' style={{ color: c.verdeClaro }}>{data.matnr}</span>
                                        </Col>
                                        <Col xs={2} sm={2} className="text-center">
                                            <span className='paragraph-3 desktop_parrafo3' style={{ color: c.azulClaro }}>{data.canti}</span>
                                        </Col>
                                    </Row>
                                </ListGroupItem>
                            )
                            }) : null}
                        </div>
                    </ListGroup>
                    <button 
                        className="btn-block bg_verde"
                        type="button"
                        onClick={TOGGLE_MODAL}
                    >
                        CERRAR
                    </button>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ModalKit;